export default __webpack_public_path__ + "static/7-fc2789f203ad763c8036335dc2dbdcc7.png";